<template>
	
  <div class="vpay__step" style="font-size: larger; text-align: center;" v-loading="loading">

    Your scheduled {{ $store.getters.recurringPaymentResponse.interval }} recurring payment of {{ $store.getters.recurringPaymentResponse.amount | formatAmount }} {{ $store.getters.recurringPaymentResponse.currency | uppercase }} for {{ $store.getters.recurringPaymentResponse.description }} has now been cancelled.

  </div>

</template>

<script>

  export default {
  
    name: "SuccessCancelRecurring",
  
  }

</script>

<style>



</style>
